import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { type FileMessage, type UserMessage } from "@sendbird/chat/message";
import { type SendableMessageType } from "@sendbird/uikit-react/types/utils";

import { MESSAGE_INPUT_SPACING } from "../../Chat/constants";
import { IconButton } from "../components/IconButton";

interface QuoteReplyProps {
  quoteMessage: SendableMessageType;
  onClose: () => void;
}

function isFileMessage(message: SendableMessageType): message is FileMessage {
  return message.messageType === "file";
}

function isUserMessage(message: SendableMessageType): message is UserMessage {
  return message.messageType === "user";
}

export function QuoteReply(props: QuoteReplyProps) {
  const { quoteMessage, onClose } = props;

  const senderName = quoteMessage.sender.nickname;

  let message = "";
  if (isFileMessage(quoteMessage)) {
    const isImageFile = quoteMessage.type.includes("image");
    message = isImageFile ? "Photo" : quoteMessage.name;
  } else if (isUserMessage(quoteMessage)) {
    ({ message } = quoteMessage);
  }

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      paddingX={MESSAGE_INPUT_SPACING}
      paddingTop={MESSAGE_INPUT_SPACING}
    >
      <Stack gap={2}>
        <Text semibold>Reply to {senderName}</Text>
        <Text variant="body2">{message}</Text>
      </Stack>

      <IconButton iconType="close" variant="ghost" onClick={onClose} />
    </Stack>
  );
}
